import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
// import FormControlLabel from "@material-ui/core/FormControlLabel";
// import Checkbox from "@material-ui/core/Checkbox";
import * as moment from "moment";
import "moment/locale/fr";
import axios from "axios";
import firebase from "firebase/app";
import Firebase, { METHODS } from "../Utils/Firebase";

import NotationBlock from "../Components/NotationBlock.jsx";
import Input from "../Components/Input/Input.base.jsx";
import Button from "../Components/Button/Button.base.jsx";
import Notifier from "../Components/Notifier.jsx";
import LoaderModule from "../Components/Loader.jsx";

const style = {
  marginTop: "150px",
  list: {
    lineHeight: "2rem",
    listStyleType: "none",
    textAlign: "justify",
    width: "500px",
    margin: "auto"
  },
  form: { marginTop: "50px", width: "80%", margin: "auto" },
  isAnonym: { marginTop: "20px" },
  button: { marginTop: "20px" }
};

class Evaluation extends Component {
  constructor() {
    super();
    this.state = {
      data: {},
      impressionValue: "",
      isAnonyme: false,
      isSending: false
    };
  }

  handleChangeImpression = (e) => {
    this.setState({ impressionValue: e.target.value });
  };

  handleChangeAnonyme = (e) => {
    this.setState({ isAnonyme: e.target.checked });
  };

  sendEmailNotification = () => {
    firebase
      .database()
      .ref(`/videos/${this.props.videoId}`)
      .once("value")
      .then((snapshot) => {
        const pitchId = this.props.videoId;
        const pitchTitle = snapshot.val().title;
        const pitchOwner = snapshot.val().userName;
        const pitchOwnerEmail = snapshot.val().userMail;

        axios({
          method: "post",
          url: process.env.REACT_APP_BASE_URL + 'send/email/',
          data: {
            pitchId,
            pitchTitle,
            pitchOwner,
            pitchOwnerEmail
          }
        })
          .then((response) => {
            console.log('email successfully send to pitch owner');
          })
          .catch((error) => {
            console.error(error);
          });
      });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const data = {
      impressions: this.state.impressionValue,
      contenu: form.contenu.value ? form.contenu.value : "1",
      organisation: form.organisation.value ? form.organisation.value : "1",
      delivrance: form.delivrance.value ? form.delivrance.value : "1",
      effect: form.effect.value ? form.effect.value : "1",
      userName: this.props.user.displayName,
      userMail: this.props.user.email,
      userAvatar: this.props.user.photoURL,
      isAnonyme: this.state.isAnonyme,
      createdAt: moment().format("DD/MM/YYYY HH:mm")
    };

    this.sendEmailNotification();
    this.setState({ data, isSending: true });
  };

  render() {
    return (
      <div style={style}>
        <h2>Aide tes pairs en les évaluant</h2>
        <p>Utilisation des critères du C.O.D.E de l’Orateur : </p>
        <ul style={style.list}>
          <li>C  pour la pertinence du CONTENU</li>
          <li>O  pour l’ORGANISATION du pitch et du temps</li>
          <li>D  pour la DELIVRANCE (débit, tics de langage…)</li>
          <li>E  pour l’EMOTION ressentie</li>
        </ul>
        <p>Bonne évaluation et n'oubliez pas de rester bienveillant.</p>
        {this.state.isSending ? (
          <Firebase
            refPath={`/videos/${this.props.videoId}/evaluations/${
              this.props.user.uid
            }`}
            method={METHODS.SET}
            data={this.state.data}
            renderSuccess={() => {
              setTimeout(() => {
                this.props.history.push("/pitchs");
              }, 1000);

              return null;
            }}
            renderPending={() => {
              return <LoaderModule />;
            }}
            renderError={() => {
              return (
                <Notifier
                  type="error"
                  message="An error was ocurred, please try again."
                />
              );
            }}
          />
        ) : (
          <form onSubmit={(e) => this.handleSubmit(e)} style={style.form}>
            <NotationBlock name="contenu" title="CONTENU" />
            <NotationBlock name="organisation" title="ORGANISATION" />
            <NotationBlock name="delivrance" title="DELIVRANCE" />
            <NotationBlock name="effect" title="l’EMOTION" />

            <Input
              type="text"
              label="Commentaire"
              name="impression"
              value={this.state.impressionValue}
              onChange={(e) => this.handleChangeImpression(e)}
              multiline
            />
            <br />

            {/* <FormControlLabel
              style={style.isAnonym}
              control={
                <Checkbox
                  checked={this.state.isAnonyme}
                  name="isAnonyme"
                  onChange={(e) => this.handleChangeAnonyme(e)}
                />
              }
              label="évaluation anonyme"
            />
            <br /> */}

            <Button type="submit" label="Envoyer" style={style.button} />
          </form>
        )}
      </div>
    );
  }
}

Evaluation.propTypes = {
  user: PropTypes.object.isRequired,
  videoId: PropTypes.string.isRequired
};

export default withRouter(Evaluation);
